import React, { useState } from 'react';
import { FixedLabelTop, FixedRow } from './styles';
import { ButtonSmall, InfoBox } from 'styles/Styles.styled';
import TextWithAnimatedEllipsis from 'components/v2/file-upload/TextWithAnimatedEllipsis';
import downloadLcdEpdByAdmin from 'util/downloadlcdEpdByAdmin';

interface Props {
  epdVersionId: string;
}

const AdminDownloadIlcdEpd: React.FC<Props> = ({ epdVersionId }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    if (isLoading) {
      return null;
    }

    setIsLoading(true);
    await downloadLcdEpdByAdmin(epdVersionId);
    setIsLoading(false);
  };

  return (
    <FixedRow>
      <FixedLabelTop>ILCD+EPD</FixedLabelTop>
      <div>
        <InfoBox>
          You can download ILCD+EPD bundle and check it in the validation tool before approving the EPD publication.
        </InfoBox>
        <ButtonSmall onClick={handleDownload}>Download ILCD+EPD</ButtonSmall>

        {isLoading && <TextWithAnimatedEllipsis style={{ marginTop: '0.5rem' }}>Generating bundle</TextWithAnimatedEllipsis>}
      </div>
    </FixedRow>
  );
};

export default AdminDownloadIlcdEpd;
